import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon", "separator"]

  toggle() {
    this.contentTarget.classList.toggle("d-none")
    const collapsed = this.contentTarget.classList.contains("d-none")
    this.iconTarget.textContent = collapsed ? "+" : "\u2014"
    this.iconTarget.style.fontSize = collapsed ? "24px" : "18px"
    if (this.hasSeparatorTarget) {
      this.separatorTarget.classList.toggle("d-none", !collapsed)
    }
  }
}
